export enum ChatTypeEnum {
  CASE = 'CASE',
  COURSE = 'COURSE'
}
